import {
  CustomStylesType,
  TemplateProvider,
  Text,
} from '@hhgtech/hhg-components/mantine'
import { CircleWarning } from '@hhgtech/icons/chat'
import { Box, Flex, rem, useMantineTheme } from '@mantine/core'
import { useIntl } from 'react-intl'

export const PfizerDisclaimer = () => {
  const { formatMessage: f } = useIntl()
  const theme = useMantineTheme()
  return (
    <TemplateProvider variant={CustomStylesType.LEADGEN}>
      <Box
        sx={{
          display: 'flex',
          background: theme.colors.neutral[0],
          border: `1px solid ${theme.colors.neutral[1]}`,
          padding: `${rem(12)} ${rem(16)}`,
          borderRadius: 8,
          [theme.fn.smallerThan('sm')]: {
            flexDirection: 'column',
            gap: 8,
          },
          [theme.fn.largerThan('sm')]: {
            gap: 40,
          },
        }}
      >
        <Flex
          gap={8}
          sx={{
            whiteSpace: 'nowrap',
            '.icon': {
              flexShrink: 0,
              marginTop: 3,
              path: {
                '&:first-child': {
                  fill: '#fff',
                },
              },
            },
          }}
        >
          <CircleWarning
            className="icon"
            size={16}
            color={theme.fn.primaryColor()}
          />
          <Text size="p3" weight="semiBold" variant="secondary">
            {f({
              id: 'pfizer.disclaimer.title',
              defaultMessage: 'Nội dung được tài trợ bởi Pfizer',
            })}
          </Text>
        </Flex>
        <Text
          size="overline"
          variant="secondary"
          sx={{
            lineHeight: rem(16),
            [theme.fn.smallerThan('sm')]: { lineHeight: rem(16) },
          }}
        >
          {f({
            id: 'pfizer.disclaimer.desc',
            defaultMessage:
              'Thông tin về sức khỏe trong tài liệu này chỉ được cung cấp cho mục đích giáo dục và không nhằm mục đích thay thế việc tham khảo ý kiến với chuyên gia tại các cơ sở y tế. Tất cả các quyết định liên quan đến việc chăm sóc bệnh nhân phải được thực hiện bởi chuyên gia tại các cơ sở y tế dựa trên việc xem xét các đặc điểm riêng biệt của từng bệnh nhân và dựa trên đánh giá và điều trị của nhân viên y tế.',
          })}
        </Text>
      </Box>
    </TemplateProvider>
  )
}
